import { FC, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { DropdownButton, DropdownOption } from '@dbt-labs/sourdough';

import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { useExposureOwners } from '@/hooks/discovery/exposreOwners';

export type OwnerFilterDropdownProps = {};

export const OWNER_PARAM = 'owner';

export const OwnerFilterDropdown: FC<OwnerFilterDropdownProps> = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { environmentId } = useDbtCloudProject();

  const [shouldFetchOwners, setShouldFetchOwners] = useState(
    searchParams.has(OWNER_PARAM),
  );

  const handleClick = () => {
    setShouldFetchOwners(true);
  };

  const [data] = useExposureOwners({
    environmentId,
    pause: !shouldFetchOwners,
  });

  const owners = data.data?.environment.applied?.owners;

  const options = useMemo(
    () => [
      { label: 'All', value: 'all' },
      ...(owners?.map(({ name }) => ({ label: name, value: name })) || []),
    ],
    [owners],
  );

  const defaultOption = useMemo((): DropdownOption => {
    const qsValue = searchParams.get(OWNER_PARAM);
    return qsValue ? { label: qsValue, value: qsValue } : options[0];
  }, [searchParams, options]);

  return (
    <div onClick={handleClick}>
      <DropdownButton
        key={options.length}
        options={options}
        name="Owner:"
        className="text-nowrap text-fgMain"
        defaultOption={defaultOption}
        listClassName="z-50"
        testId="owner-filter-dropdown"
        onChange={({ value }) => {
          if (typeof value !== 'string') return;
          if (value === 'all') {
            setSearchParams((p) => {
              p.delete(OWNER_PARAM);
              return p;
            });
          } else {
            setSearchParams((p) => {
              p.set(OWNER_PARAM, value);
              return p;
            });
          }
        }}
      />
    </div>
  );
};
